import { TriangleAlertIcon } from 'lucide-react'

import { useFlaggedCheckFiles } from '@/modules/projects/hooks'
import { flaggedCheckFileNote } from './noteText'

// One note per file whose checks the engine flagged, naming the pages that need a look.
export const FlaggedChecksNote = () => {
  const flaggedFiles = useFlaggedCheckFiles()
  if (flaggedFiles.length === 0) return null

  return (
    <ul className="flex flex-col gap-2">
      {flaggedFiles.map((file) => (
        <li
          key={file.statementId}
          className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
        >
          <TriangleAlertIcon className="mt-0.5 size-4 shrink-0" />
          <span>
            <strong>{file.fileName}</strong>: {flaggedCheckFileNote(file)}
          </span>
        </li>
      ))}
    </ul>
  )
}
